import { create } from 'zustand';

/**
 * UI-only search state. Server data (listings, totals, facets) lives in React
 * Query; filter state lives in the URL (including the map-area bbox). This
 * store holds what belongs to neither: the map viewport and cross-component
 * hover/selection sync.
 */
interface SearchUIState {
  mapCenter: { lat: number; lng: number };
  mapZoom: number;
  hoveredListingId: string | null;
  selectedListingId: string | null;
  /** When on, panning the map auto-applies the bbox instead of offering the pill. */
  searchAsIMove: boolean;

  setMapCenter: (center: { lat: number; lng: number }) => void;
  setSearchAsIMove: (v: boolean) => void;
  setMapZoom: (zoom: number) => void;
  setHoveredListing: (id: string | null) => void;
  setSelectedListing: (id: string | null) => void;
}

// Bay Area center
const DEFAULT_MAP_CENTER = { lat: 37.5, lng: -122.1 };
const DEFAULT_MAP_ZOOM = 10;

export const useSearchStore = create<SearchUIState>((set) => ({
  mapCenter: DEFAULT_MAP_CENTER,
  mapZoom: DEFAULT_MAP_ZOOM,
  hoveredListingId: null,
  selectedListingId: null,
  searchAsIMove: false,

  setMapCenter: (mapCenter) => set({ mapCenter }),
  setSearchAsIMove: (searchAsIMove) => set({ searchAsIMove }),
  setMapZoom: (mapZoom) => set({ mapZoom }),
  setHoveredListing: (hoveredListingId) => set({ hoveredListingId }),
  setSelectedListing: (selectedListingId) => set({ selectedListingId }),
}));
